import SearchAPI from '@/api/search'

const openSearchForm = ({ commit }) => commit('OPEN_SEARCH_FORM')
const closeSearchForm = ({ commit }) => commit('CLOSE_SEARCH_FORM')
const setHeaderFix = ({ commit }, value) => commit('SET_HEADER_FIX', value)

/**
 * 검색어를 이용하여 제품 검색 요청을 한다.
 * @param {*} param0
 * @param {Object} param1
 * @param {String} param1.searchText - 검색어
 * @param {Boolean} param1.reset - 초기화 여부
 */
const searchProduct = (
  { commit, getters, rootGetters, dispatch },
  { searchText, reset }
) => {
  const { productList } = getters['product']
  if (rootGetters['main/requestPossible'] || productList.length === 0) {
    if (reset) {
      commit('SET_PRODUCT_LIST', { page: 0, productList: [], last: false })
    }
    const { page, pageSize, last } = getters['product']
    if (last === false) {
      SearchAPI.searchProduct(searchText, page, pageSize, responseData => {
        commit('SET_PRODUCT_LIST', {
          page: page + 1,
          productList: responseData.data.productList || [],
          totalCount: responseData.data.totalCount || 0
        })
      })
    }
  } else if (getters['requestPossible'] === false) {
    dispatch('main/setRequestPossible', true, { root: true })
  }
}
/**
 * 검색어를 이용하여 태그 검색 요청을 한다.
 * @param {*} param0
 * @param {String} searchText - 검색어
 */
const searchTag = ({ commit, getters, rootGetters, dispatch }, searchText) => {
  if (rootGetters['main/requestPossible'] || getters['tagList'].length === 0) {
    SearchAPI.searchTag(searchText, responseData => {
      commit('SET_TAG_LIST', { tagList: responseData.data.tagList, totalCount: responseData.data.totalCount })
    })
  } else if (getters['requestPossible'] === false) {
    dispatch('main/setRequestPossible', true, { root: true })
  }
}

// 검색화면 첫 진입 + 검색어 변경
const searchBoth = (
  { commit, getters, rootGetters, dispatch },
  { searchText }
) => {
  if (rootGetters['main/requestPossible']) {
    commit('SET_PRODUCT_LIST', { page: 0, productList: [], last: false })
    commit('SET_TAG_LIST',{ tagList: [], totalCount: 0 } )

    const { page, pageSize, last } = getters['product']
    if (last === false) {
      SearchAPI.searchProduct(searchText, page, pageSize, responseData => {
        commit('SET_PRODUCT_LIST', {
          page: page + 1,
          productList: responseData.data.productList || [],
          totalCount: responseData.data.totalCount || 0
        })
      })
    }
    SearchAPI.searchTag(searchText, responseData => {
      commit('SET_TAG_LIST', { tagList: responseData.data.tagList, totalCount: responseData.data.totalCount })
    })
  } else if (getters['requestPossible'] === false) {
    dispatch('main/setRequestPossible', true, { root: true })
  }
}

export default {
  openSearchForm,
  closeSearchForm,
  setHeaderFix,
  searchProduct,
  searchTag,
  searchBoth
}
